import ApplicantMessengerMessageForm from './ApplicantMessengerMessageForm';

export default ApplicantMessengerMessageForm;
